import React from "react";
import { render } from "react-dom";
import { map } from "lodash";

import Browse from "widgets/Browse";
import dataScroll from "helpers/dataScroll";
import Fees from "components/Fees";

import "./style.scss";

dataScroll();

const pages = {
  "js-fees": () => <Fees />,
  browse: () => <Browse />,
};

map(pages, (jsx, jsElement) => {
  const ele = document.getElementById(jsElement);
  if (ele) {
    render(jsx(), ele);
  }
});
